import React from "react";

import { Grid } from "@mui/material";
import { FiTrash2 } from "react-icons/fi";

import useStyles from "../../styles";

interface Props {
  show?: boolean;

  deleteCarton: () => void;
}

const DeleteCartonButton = (props: Props) => {
  const { show, deleteCarton } = props;

  const classes = useStyles();

  if (!deleteCarton || !show) return null;

  return (
    <Grid item data-cy="delete-sscc" className={classes.actionButton}>
      <div onClick={() => deleteCarton()}>
        <FiTrash2 color="rgb(207, 42, 39)" size={24} />
      </div>
    </Grid>
  );
};

export default DeleteCartonButton;
